export const MEDIA_CATEGORY_UNSPECIFIED = 'CATEGORY_UNSPECIFIED';
export const MEDIA_CATEGORY_COVER = 'COVER';
export const MEDIA_CATEGORY_PROFILE = 'PROFILE';
export const MEDIA_CATEGORY_EXTERIOR = 'EXTERIOR';
export const MEDIA_CATEGORY_INTERIOR = 'INTERIOR';
export const MEDIA_CATEGORY_PRODUCT = 'PRODUCT';
export const MEDIA_CATEGORY_AT_WORK = 'AT_WORK';
export const MEDIA_CATEGORY_FOOD_AND_DRINK = 'FOOD_AND_DRINK';
export const MEDIA_CATEGORY_MENU = 'MENU';
export const MEDIA_CATEGORY_COMMON_AREA = 'COMMON_AREA';
export const MEDIA_CATEGORY_ROOMS = 'ROOMS';
export const MEDIA_CATEGORY_TEAMS = 'TEAMS';
export const MEDIA_CATEGORY_ADDITIONAL = 'ADDITIONAL';

export const SINGLE_IMAGE_CATEGORIES = [MEDIA_CATEGORY_COVER, MEDIA_CATEGORY_PROFILE];

export const MULTIPLE_IMAGE_CATEGORIES = [
  MEDIA_CATEGORY_INTERIOR,
  MEDIA_CATEGORY_EXTERIOR,
  MEDIA_CATEGORY_AT_WORK,
  MEDIA_CATEGORY_TEAMS,
  MEDIA_CATEGORY_FOOD_AND_DRINK,
  MEDIA_CATEGORY_MENU,
  MEDIA_CATEGORY_PRODUCT,
  MEDIA_CATEGORY_ADDITIONAL,
  MEDIA_CATEGORY_UNSPECIFIED,
];

export const LOGO_SELECTION_HELP_TOOLTIP =
  'Your logo reinforces brand recognition across Google. Upload a clear, square logo (recommended: 1000x1000 px, 1:1 ratio). Use a transparent background if possible, and avoid text-heavy or low-contrast images. Minimum requirements: 250px on the short edge and 10KB file size.';

export const PROFILE_SELECTION_HELP_TOOLTIP =
  'The profile photo represents your business in search and map listings. Use a centered, high-resolution headshot or brand image (recommended: 720x720 px or higher, 1:1 ratio). Keep the background neutral and image sharp. Minimum requirements: 250px on the short edge and 10KB file size.';

export const COVER_SELECTION_HELP_TOOLTIP =
  "The cover photo is your business's visual banner. Choose a wide, engaging image of your storefront, workspace, or key service (recommended: 1920x1080 px, 16:9 ratio). Use natural lighting and avoid text overlays. Minimum requirements: 250px on the short edge and 10KB file size.";

export const ADDITIONAL_IMAGES_SELECTION_HELP_TOOLTIP =
  'Additional photos help customers explore your business more deeply. Show interior spaces, team members, products, or food (recommended: 1024x768 px or higher, 4:3 or 1:1 ratio). Ensure clarity, relevance, and good lighting. Minimum requirements: 250px on the short edge and 10KB file size.';
